// applications/_shared hooks — shared across this module's features.
// TanStack Query (useQuery) only. Pure API functions belong in services/.
import { useQuery } from "@tanstack/react-query";
import { STALE_TIME } from "@core/libs/react-query";
import { applicationKeys } from "../keys";
import { listInformationRequests } from "../services/information-request";

/** Every open/past request against one dossier (US-E4-04/US-E7-05). Shared by `espace` (checking
 * whether a submitted dossier has anything outstanding) and `respond` (rendering each one) — see
 * `types/information-request.ts`'s own doc comment for why this lives here, not in one feature. */
export function useInformationRequests(applicationId: string) {
  return useQuery({
    queryKey: applicationKeys.informationRequests(applicationId),
    queryFn: () => listInformationRequests(applicationId),
    enabled: !!applicationId,
    staleTime: STALE_TIME.operational,
  });
}
